import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  dropoffNearbyFromModel,
  validateDropoffNearbyCondition,
  type DropoffNearbyState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DROPOFF_NEARBY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DropoffNearbyState>>,
): ConditionType<DropoffNearbyState, Condition.DropoffNearby> => ({
  name: CONDITION_NAMES[Condition.DROPOFF_NEARBY],
  description(state) {
    if (state === undefined) {
      return t("A drop-off location is within the set distance (miles)");
    }
    return t("A drop-off location is within {{count}} miles", {
      count: +state,
    });
  },
  Details(props: ConditionTypeDetailsProps<DropoffNearbyState>) {
    return React.createElement(Details, props);
  },
  empty: (5).toFixed(0),
  fromModel(model) {
    return dropoffNearbyFromModel(model);
  },
  toModel(state) {
    return { type: Condition.DROPOFF_NEARBY, maxDistanceMiles: +state };
  },
  valid(state) {
    return validateDropoffNearbyCondition(state).valid;
  },
});
